module.exports = __webpack_public_path__ + "img/asset_ETH-USDC.f50ecf47.png";